import React from 'react';

const Contact = React.forwardRef((props, ref) => (
  <section 
    id="contact" 
    ref={ref} 
    data-animate
    className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-20 px-8"
  >
    <div className="container mx-auto max-w-4xl">
      <h2 className="text-4xl font-bold mb-16 text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
        Get In Touch
      </h2>

      <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="grid">
          <div className="p-10 bg-gradient-to-br from-blue-500 to-purple-600 text-white flex flex-col justify-center">
            <h3 className="text-2xl font-bold mb-4">Contact Information</h3>
            <p className="mb-6">Feel free to reach out for collaborations or just to say hello!</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  ✉️
                </div>
                <span>contact@glitchdoctor.co.uk</span>
              </div>
             
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  🏢
                </div>
                <span>Birmingham, UK</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  🔗
                </div>
                <a href="https://www.linkedin.com/in/joseph-d-a17664151/" target="_blank" rel="noopener noreferrer" className="hover:underline">
                  LinkedIn
                </a>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  💻
                </div>
                <a href="https://github.com/joedrozd" target="_blank" rel="noopener noreferrer" className="hover:underline">
                  GitHub
                </a>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  🧵
                </div>
                <a href="https://www.threads.com/@glitchdoctordev" target="_blank" rel="noopener noreferrer" className="hover:underline">
                  Threads
                </a>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  𝕏
                </div>
                <a href="https://x.com/Gltchdctr" target="_blank" rel="noopener noreferrer" className="hover:underline">
                  Twitter/X
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
));

export default Contact;
